import { all, put, takeLatest, call } from 'redux-saga/effects';
import { showLoading, hideLoading } from '../../actions/Login/action';
import { getSubmitFeedback } from '../../actions/Menu/action';
import * as constants from '../../utils/constants';
import request from '../../utils/request';
import { DomainConverter } from '../../utils/common';

export function* submitFeedback(action: any) {
  const { callback } = action.payload;
  try {
    yield put(showLoading());
    const submitFeedbackQuery = DomainConverter.domainToData(
      action.payload.data
    );
    const fetchFeedback = yield call(request, [
      'SUBMITFEEDBACK',
      'SUBMITFEEDBACK',
      null,
      '',
      submitFeedbackQuery,
      'application/json'
    ]);
    yield put(getSubmitFeedback(fetchFeedback));
    yield put(hideLoading());
    if (
      fetchFeedback &&
      fetchFeedback.data &&
      fetchFeedback.data.feedback === true
    ) {
      callback();
    }
  } catch (e) {
    yield put(hideLoading());
  }
}

export default function* rootSaga() {
  yield all([takeLatest(constants.SUBMIT_FEEDBACK, submitFeedback)]);
}
